import React from "react";
import { AppHeaderStore } from "@/app/uistore/AppheaderStore";
import { Bootstrapping } from "@/app/uistore/BootstrappingStore";
import { RegisterStore } from "@/app/uistore/RegisterStore";
import { LoginViewStore } from "@/app/uistore/LoginViewStore";
import { HomeViewStore } from "@/app/uistore/HomeViewStore";
import { AuthStore } from "@/app/uistore/AuthStore";
import { AletrDialogStore } from "@/app/uistore/AlertDialogStore";
import { ConfirmStore } from "./ConfirmDialogStore";
import { EditorStore } from "./EditorStore";
import { APPEvent } from "@/events/AppEvents";
import { GroupStore } from "@/app/uistore/GroupStore";
import { WorkingDialogState } from "@/app/uistore/WorkingDialogStore";
import { AdminStore } from "@/app/uistore/AdminStore";
import { LetrwingLinkStore } from "./LetrwingLinkStore";
import { LetrAndTagsStore } from "@/app/uistore/LetrAndTagsStore";
import { MessageUIStore } from "@/app/uistore/MessageUIStore";
import { RepliesUIStore } from "@/app/uistore/RepliesUIStore";
import { LetrDetailsStore } from "@/app/uistore/LetrDetailStore";
import { FilterStore } from "@/app/uistore/FilterStore";
import { DeviceStore } from "@/app/uistore/DeviceStore";
import { DocumentDetailStore } from "@/app/uistore/DocumentDetailsStore";
import { AppState } from "@/share/AppState";
import { AllRepliesUIStore } from "@/app/uistore/AllRepliesUIStore";
import { ManagedLetrsUIStore } from "@/app/uistore/ManagedLetrsStore";
import { AssignedDetailsStore } from "./AssignedDetailStore";
import { UnreadInfoStore } from "./UnreadStore";
import { ConnectViewState } from "./ConnectViewState";
import { LoginViaDeviceUIStore } from "./LoginViaDeviceUIStore";
import { MediaStore } from "@/media/MediaStore";
import { ProjectStore } from "./ProjectStore";
import { MainViewerState } from "./MainViewerState";
import { MessageReadDialogState } from "./MessageReadState";
import { PoliciesStore } from "@/app/uistore/PolicyUIStore";
import { UserStore } from "@/app/uistore/UserUIStore";
import { UserContactStore } from "./UserContactStore";
import { UserProfileUIStore } from "./UserProfileUIStore";
import { ActiveContactStore } from "./ActiveContactStore";
import { MiniViwerState } from "./MiniViwerState";
import { DraftDetailViewStore } from "./DraftDetailViewStore";
import { CallHistoryUIStore } from "./CallHistoryUIStore";
import { AdminViewStore } from "./AdminViewStore";
import { SettingsUIStore } from "@/app/admin/uistore/SettingsUIStore";
import { AdminDeviceViewStore } from "@/app/admin/uistore/AdminDeviceViewStore";
import { EditUserViewStore, UsersViewStore } from "@/app/admin/uistore/UsersViewStore";
import { AdminTagLetrInfiniteStore } from "@/app/admin/uistore/AdminTagLetrInfiniteStore";
import { AdminLetrViewStore } from "@/app/admin/uistore/AdminLetrViewStore";
import { LetrSearchStore } from "@/app/uistore/LetrSearchStore";
import { SearchStore } from "@/app/uistore/SearchStore";
import { AdminMessageUIStore } from "@/app/admin/uistore/AdminMessageUIStore";
import { AdminProjectUIStore } from "../admin/uistore/AdminProjectUIStore";
import { AdminDocumentDetailStore } from "../admin/uistore/AdminDocumentDetailStore";
import { AdminDraftDetailViewStore } from "../admin/uistore/AdminDraftDetailViewStore";
import { AdminRepliesUIStore } from "../admin/uistore/AdminRepliesUIStore";
import { AdminMainViewerState } from "../admin/uistore/AdminMainViewerState";
import { TabStore } from "./TabStore";
import { DisplayRecoveryState } from "./DisplayRecoveryState";
import { RecoveryRevealDialogState } from "./RecoveryRevealDialogState";
import { ResetPasswordStore } from "./ResetPasswordStore";
import { FloatingObjectViewerState } from "./FloatingObjectViewerState";
import { ObjectChooserState } from "./ObjectChooserState";
import { FloatingPdfViewerStore } from "./FloatingPdfViewerStore";
import { FloatingDraftViewStore } from "./FloatingDraftViewerStore";
import { CalendarState } from "./CalendarState";
import { AddEventStore } from "./AddEventStore";
import { AddMiscContactStore } from "./AddMiscContactStore";
import { SchemaDialogState } from "./SchemaDialogState";
import { SchemaStore } from "./SchemaStore";
import { DatasheetDialogState } from "./DatasheetState";
import { DatasheetStore } from "./Datasheestore";
import { FLoatingDatasheetStore } from "./FloatingDatasheetStore";
import { AdminMiniViwerStateNew } from "../admin/uistore/AdminMiniViewerStateNew";
import { AdminDatasheetStore } from "../admin/uistore/AdminDatasheetStore";
import { AdminSchemaStore } from "../admin/uistore/AdminSchemaStore";
import { MetadataDialogState } from "./MetadataDialogState";
import { SchemaWebFormListStore } from "./SchemaWebFormListStore";
import { WorksheetPrintTemplateStore } from "./WorksheetPringTemplateStore";
import { AdminFloatingDatasheetStore } from "../admin/uistore/AdminFloatingDatasheetStore";
import { AdminFloatingPdfViewerStore } from "../admin/uistore/AdminFloatingPdfViewerStore";
import { AdminFloatingObjectViewerState } from "../admin/uistore/AdminFloatingObjectViewerState";
import { AdminFloatingDraftViewStore } from "../admin/uistore/AdminFloatingDraftViewStore";
import { PwaStore } from "./PwaStore";
import { RemoteDatasheetStore } from "./RemoteDatasheetStore";
import { IntegrationDialogState } from "./IntegrationDialogState";
import { CustomdisplayFormState } from "./CustomDisplayFormState";
export const StoreContext = React.createContext(null);
export class RootStore {
    constructor() {
        this.pwastore = new PwaStore();
        this.regstore = new RegisterStore();
        this.bootstore = new Bootstrapping();
        this.appheaderstore = new AppHeaderStore();
        this.loginviewstore = new LoginViewStore();
        this.homeviewstore = new HomeViewStore();
        this.authstore = new AuthStore();
        this.alertstore = new AletrDialogStore();
        this.confirmstore = new ConfirmStore();
        this.editorstore = new EditorStore();
        this.groupstore = new GroupStore();
        this.workingdialog = new WorkingDialogState();
        this.adminstore = new AdminStore();
        this.letrwinglinkstore = new LetrwingLinkStore();
        this.tagsLetrstore = new LetrAndTagsStore();
        this.messagestore = new MessageUIStore();
        this.repliesstore = new RepliesUIStore();
        this.letrdetailstore = new LetrDetailsStore();
        this.filterstore = new FilterStore();
        this.devicestore = new DeviceStore();
        this.documentdetailstore = new DocumentDetailStore();
        this.allrepliesstore = new AllRepliesUIStore();
        this.managedletrsstore = new ManagedLetrsUIStore();
        this.letrassignedstore = new AssignedDetailsStore();
        this.unreadstore = new UnreadInfoStore();
        this.connectstore = new ConnectViewState();
        this.loginviadeviceuistore = new LoginViaDeviceUIStore();
        this.mstore = new MediaStore();
        this.projectstore = new ProjectStore();
        this.mainviewstore = new MainViewerState();
        this.messagereadstore = new MessageReadDialogState();
        this.policiesstore = new PoliciesStore();
        this.useruistore = new UserStore();
        this.usercontactstore = new UserContactStore();
        this.userprofileuistore = new UserProfileUIStore();
        this.activecontactstore = new ActiveContactStore();
        this.miniviewstore = new MiniViwerState();
        this.draftdetailstore = new DraftDetailViewStore();
        this.callhistoryuistore = new CallHistoryUIStore();
        this.adminviewstore = new AdminViewStore();
        this.settingsuistore = new SettingsUIStore();
        this.deviceviewstore = new AdminDeviceViewStore();
        this.usersviewstore = new UsersViewStore();
        this.adminletrviewstore = new AdminLetrViewStore();
        this.admintagviewstore = new AdminTagLetrInfiniteStore();
        this.edituserstore = new EditUserViewStore();
        this.letrsearchstore = new LetrSearchStore();
        this.searchstore = new SearchStore();
        this.adminmessagestore = new AdminMessageUIStore();
        this.adminprojectstore = new AdminProjectUIStore();
        this.adminminiviewstore = new AdminMiniViwerStateNew();
        this.admindocumentdetailstore = new AdminDocumentDetailStore();
        this.admindraftdetailstore = new AdminDraftDetailViewStore();
        this.adminrepliesstore = new AdminRepliesUIStore();
        this.adminmainviewstore = new AdminMainViewerState();
        this.tabstore = new TabStore();
        this.dissecstore = new DisplayRecoveryState();
        this.reccodestate = new RecoveryRevealDialogState();
        this.resetstore = new ResetPasswordStore();
        this.floatingstore = new FloatingObjectViewerState();
        this.objectchooserstore = new ObjectChooserState();
        this.floatingpdfviewerstore = new FloatingPdfViewerStore();
        this.floatingdraftstore = new FloatingDraftViewStore();
        this.calendarstore = new CalendarState();
        this.addevenstore = new AddEventStore();
        this.miscstore = new AddMiscContactStore();
        this.schemastore = new SchemaDialogState();
        this.mainschemastore = new SchemaStore();
        this.datasheetdialogstore = new DatasheetDialogState();
        this.datasheetstore = new DatasheetStore();
        this.floatingschemastore = new FLoatingDatasheetStore();
        this.admindatasheetstore = new AdminDatasheetStore();
        this.adminmainschemastore = new AdminSchemaStore();
        this.metadataschemastore = new MetadataDialogState();
        this.schemaWebForm = new SchemaWebFormListStore();
        this.printtemplate = new WorksheetPrintTemplateStore();
        this.adminfloatingschemastore = new AdminFloatingDatasheetStore();
        this.adminfloatingpdfviewerstore = new AdminFloatingPdfViewerStore();
        this.adminfloatingstore = new AdminFloatingObjectViewerState();
        this.adminfloatingdraftstore = new AdminFloatingDraftViewStore();
        this.remoteschemastore = new RemoteDatasheetStore();
        this.integrationstore = new IntegrationDialogState();
        this.customformstate = new CustomdisplayFormState();
        APPEvent.addSubscriberForReset(() => this.reset());
        APPEvent.addSubscriberForAppState((state) => {
            if (state === AppState.Logout) {
                this.reset();
            }
            else if (state === AppState.Login) {
                this.reset();
            }
        });
        APPEvent.addSubscriberForReset(() => this.reset());
        APPEvent.addSubscriberForCloseWorkingDialog(() => this.workingdialog.setOpen(false));
    }
    getPwaStore() {
        return this.pwastore;
    }
    get metadataStore() {
        return this.metadataschemastore;
    }
    get worksheetPrintTemplateStore() {
        return this.printtemplate;
    }
    get schemaWebFormStore() {
        return this.schemaWebForm;
    }
    get schemaStore() {
        return this.schemastore;
    }
    get addMiscStore() {
        return this.miscstore;
    }
    get addEventStore() {
        return this.addevenstore;
    }
    get floatingDraftViewStore() {
        return this.floatingdraftstore;
    }
    get floatingPdfViewerStore() {
        return this.floatingpdfviewerstore;
    }
    get objectChooserStore() {
        return this.objectchooserstore;
    }
    get floatingStore() {
        return this.floatingstore;
    }
    get calendarStore() {
        return this.calendarstore;
    }
    get resetStore() {
        return this.resetstore;
    }
    get displayRecoveryState() {
        return this.dissecstore;
    }
    get searchStore() {
        return this.searchstore;
    }
    get tabStore() {
        return this.tabstore;
    }
    get mainviewStore() {
        return this.mainviewstore;
    }
    get letrSearchStore() {
        return this.letrsearchstore;
    }
    get miniviewStore() {
        return this.miniviewstore;
    }
    get recoveryCodeDialog() {
        return this.reccodestate;
    }
    get draftDetailStore() {
        return this.draftdetailstore;
    }
    get projectStore() {
        return this.projectstore;
    }
    get mediastore() {
        return this.mstore;
    }
    get connectStore() {
        return this.connectstore;
    }
    get managedLetrsStore() {
        return this.managedletrsstore;
    }
    get documentDetailStore() {
        return this.documentdetailstore;
    }
    get letrDetailStore() {
        return this.letrdetailstore;
    }
    get deviceStore() {
        return this.devicestore;
    }
    get repliesStore() {
        return this.repliesstore;
    }
    get confirmStore() {
        return this.confirmstore;
    }
    get adminStore() {
        return this.adminstore;
    }
    get workingStore() {
        return this.workingdialog;
    }
    get groupStore() {
        return this.groupstore;
    }
    get authStore() {
        return this.authstore;
    }
    get aletrDialogStore() {
        return this.alertstore;
    }
    get registerStore() {
        return this.regstore;
    }
    get bootStore() {
        return this.bootstore;
    }
    get appheaderStore() {
        return this.appheaderstore;
    }
    get loginViewStore() {
        return this.loginviewstore;
    }
    get homeViewStore() {
        return this.homeviewstore;
    }
    get adminViewStore() {
        return this.adminviewstore;
    }
    get editorStore() {
        return this.editorstore;
    }
    get unreadStore() {
        return this.unreadstore;
    }
    get letrwingLinkStore() {
        return this.letrwinglinkstore;
    }
    get letrAndTagStore() {
        return this.tagsLetrstore;
    }
    get messageStore() {
        return this.messagestore;
    }
    get filterStore() {
        return this.filterstore;
    }
    get allrepliesStore() {
        return this.allrepliesstore;
    }
    get letrassignedStore() {
        return this.letrassignedstore;
    }
    get loginViaDeviceUIStore() {
        return this.loginviadeviceuistore;
    }
    get messageReadStore() {
        return this.messagereadstore;
    }
    get policiesStore() {
        return this.policiesstore;
    }
    get userStore() {
        return this.useruistore;
    }
    get userContactStore() {
        return this.usercontactstore;
    }
    get userProfileUIStore() {
        return this.userprofileuistore;
    }
    get activeMemberStore() {
        return this.activecontactstore;
    }
    get callHistoryUIStore() {
        return this.callhistoryuistore;
    }
    get settingsUIStore() {
        return this.settingsuistore;
    }
    get adminDeviceViewStore() {
        return this.deviceviewstore;
    }
    get usersViewStore() {
        return this.usersviewstore;
    }
    get adminLetrViewStore() {
        return this.adminletrviewstore;
    }
    get adminTagViewStore() {
        return this.admintagviewstore;
    }
    get edituserStore() {
        return this.edituserstore;
    }
    get adminMessageStore() {
        return this.adminmessagestore;
    }
    get adminProjectStore() {
        return this.adminprojectstore;
    }
    get adminMiniviewStore() {
        return this.adminminiviewstore;
    }
    get adminDocumentDetailStore() {
        return this.admindocumentdetailstore;
    }
    get adminDraftDetailStore() {
        return this.admindraftdetailstore;
    }
    get adminRepliesStore() {
        return this.adminrepliesstore;
    }
    get adminMainViewStore() {
        return this.adminmainviewstore;
    }
    get mainSchemaStore() {
        return this.mainschemastore;
    }
    get adminMainSchemaStore() {
        return this.adminmainschemastore;
    }
    get datasheetDialogState() {
        return this.datasheetdialogstore;
    }
    get datasheetStore() {
        return this.datasheetstore;
    }
    get adminDatasheetStore() {
        return this.admindatasheetstore;
    }
    get floatingDatasheetStore() {
        return this.floatingschemastore;
    }
    get adminFloatingDatasheetStore() {
        return this.adminfloatingschemastore;
    }
    get adminFloatingPdfViewerStore() {
        return this.adminfloatingpdfviewerstore;
    }
    get adminFloatingStore() {
        return this.adminfloatingstore;
    }
    get adminFloatingDraftViewStore() {
        return this.adminfloatingdraftstore;
    }
    get remoteDatasheetStore() {
        return this.remoteschemastore;
    }
    reset() {
        this.regstore.reset();
        this.bootstore = new Bootstrapping();
        this.appheaderstore.reset();
        this.loginviewstore.reset();
        this.homeviewstore.reset();
        this.adminstore.reset();
        this.letrwingLinkStore.reset();
        this.tagsLetrstore.reset();
        this.messagestore.reset();
        this.deviceStore.reset();
        this.filterstore.reset();
        this.documentDetailStore.reset();
        this.allrepliesstore.reset();
        this.managedletrsstore.reset();
        this.unreadstore.reset();
        this.connectstore.reset();
        this.draftDetailStore.resetNotes();
        this.projectStore.setViewerActive(false);
        this.projectStore.setSearchActive(false);
        this.letrAndTagStore.reset();
        this.letrAndTagStore.firstload = true;
        this.mainSchemaStore.reset();
        this.floatingschemastore.reset();
        this.loginviadeviceuistore.reset();
        this.mstore.disconnect();
        this.messagereadstore.reset();
        this.policiesstore.reset();
        this.useruistore.reset();
        this.userContactStore.reset();
        this.userprofileuistore.reset();
        this.activecontactstore.reset();
        this.callhistoryuistore.reset();
        this.adminviewstore.reset();
        this.adminmessagestore.reset();
        this.adminminiviewstore.reset();
        this.admindocumentdetailstore.reset();
        // this.admindraftdetailstore.reset();
        this.adminrepliesstore.reset();
        this.objectChooserStore.reset();
        this.floatingStore.reset();
        this.addEventStore.reset();
        this.schemastore.reset();
        this.adminmainviewstore.reset();
        this.admindatasheetstore.reset();
        this.adminmainschemastore.reset();
        this.adminfloatingschemastore.reset();
        this.adminfloatingpdfviewerstore.reset();
        this.adminfloatingstore.reset();
        this.remoteschemastore.reset();
    }
}
